import { MixpanelPeopleProperties } from '@/integrations/analytics/constants/MixpanelPeopleProperties';
import Enum from '/@/modules/core/app/helpers/Enum';

// Full list at - https://docs.mixpanel.com/docs/data-structure/property-reference/reserved-properties#reserved-profile-properties
export class MixpanelReservedProfileProperties extends Enum {
  static NAME = '$name';
  static EMAIL = '$email';
  static PHONE = '$phone';
  static CREATED = '$created';

  static getReservedProfileProperty(value: string): MixpanelReservedProfileProperties | string {
    switch (value) {
      case MixpanelPeopleProperties.NAME:
        return MixpanelReservedProfileProperties.NAME;
      case MixpanelPeopleProperties.EMAIL:
        return MixpanelReservedProfileProperties.EMAIL;
      case MixpanelPeopleProperties.CREATED_AT:
        return MixpanelReservedProfileProperties.CREATED;
      default:
        return value;
    }
  }
}
